import Cookies from 'universal-cookie'

const cookies = new Cookies()

export default cookies